import { makeResource, mapped } from '@codium/codium-vue'
import { http } from '@/utils'

export const { storeModule, helperComputed, helperMethods, stateMapper } = makeResource('settings/energyProviders', {
  namespaced: true,
  storeModule: {
    actions: {
      async restoreEnergyProvider ({ getters }, item) {
        await http.put(`${getters.uri()}/${item.id}/restore`, item)
      }
    },
  },

  resource () {
    return {
      id: null,
      name: mapped(null),
      url: mapped(null),
      archived: null
    }
  }
})
